const EL = '.js-GalleryMasonry'

import Masonry from 'masonry-layout';

if(document.querySelector(EL)){
  new Masonry( EL, {
    gutter: 10
  });
}
